export default "__VITE_ASSET__if5g_VNB__"